(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
     Lfl.Mobile = Lfl.Mobile || {};

    (function (Mobile, $, undefined) {
        if(Lfl.Files.isLoadedAlready(Lfl.Mobile, 'Firebase')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Works with Firebase Cloud Messaging tokens created on mobile device
         *
         * @memberOf Lfl.Mobile
         */
        Lfl.Mobile.Firebase = Mobile.Firebase || {};

        (function (Firebase, $, undefined) {
            /*
            |===========================================================================================================
            | Object definition
            |===========================================================================================================
            */

            var registerTokenUrl =  "";

            /**
             * @param parameters
             * @param parameters.registerTokenUrl
             * @memberOf Lfl.Mobile.Firebase
             */
            Firebase.init = function (parameters) {
                registerTokenUrl = parameters.registerTokenUrl;
            };

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Public methods
            |-----------------------------------------------------------------------------------------------------------
            */

            /**
             * @memberOf Lfl.Mobile.Firebase
             */
            Firebase.registerToken = function (fcmToken, platform) {
                if (typeof registerTokenUrl === 'undefined') {
                    throw new Error("This object was not properly initialized and cannot be used in this state. Missing registerTokenUrl value.");
                }

                $.ajax({
                    type: 'put',
                    url: registerTokenUrl,
                    dataType: 'json',
                    data: {
                        token: fcmToken,
                        platform: platform
                    },
                    success: function (data) {
                        Lfl.Mobile.Sender.tokenRegistered(data.success);
                    },
                    error: function (x, errorText, y) {
                        Lfl.Mobile.Sender.tokenRegistered(false);
                    }

                });
            };

            /*
            |-----------------------------------------------------------------------------------------------------------
            | Private methods
            |-----------------------------------------------------------------------------------------------------------
            */
        }(Mobile.Firebase, jQuery));
    }(Lfl.Mobile, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
